'use client';

import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';

import { NewsCategory } from '../../../services/types/news';

export interface CategoryTabsProps {
  categories: NewsCategory[];
  activeCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

const CategoryTabs = ({
  categories,
  activeCategory,
  onCategoryChange,
}: CategoryTabsProps) => {
  const allCategories = [
    { id: 0, name: 'Tất cả', slug: null, color: '#EB722E', order: 0 },
    ...categories.filter(cat => cat.slug !== 'tat-ca'),
  ];

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    onCategoryChange(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Tabs
        value={activeCategory}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
        sx={{
          '& .MuiTabs-scrollButtons': {
            '&.Mui-disabled': {
              opacity: 0.3,
            },
          },
          '& .MuiTabs-indicator': {
            height: 4,
            backgroundColor: 'rgba(149, 255, 0, 0)',
            borderRadius: '2px',
          },
          '& .MuiTabScrollButton-root': {
            color: '#999999',
          },
        }}
      >
        {allCategories.map(category => (
          <Tab
            key={category.slug || 'all'}
            label={category.name}
            value={category.slug}
            sx={{
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: activeCategory === category.slug ? 700 : 510,
              fontFamily:
                'SF Pro, -apple-system, BlinkMacSystemFont, sans-serif',
              color: activeCategory === category.slug ? '#1A1A1A' : '#E5F2FF',
              minWidth: 'auto',
              px: 3,
              py: 1,
              '&:hover': {
                color: activeCategory === category.slug ? '#1A1A1A' : '#FFFFFF',
              },
              '&.Mui-selected': {
                color: '#1A1A1A',
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoryTabs;
